import { render, staticRenderFns } from "./CardsSettingsPanel.vue?vue&type=template&id=658bb570&"
import script from "./CardsSettingsPanel.vue?vue&type=script&lang=js&"
export * from "./CardsSettingsPanel.vue?vue&type=script&lang=js&"
import style0 from "./CardsSettingsPanel.vue?vue&type=style&index=0&id=658bb570&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports